<template>
  <div>
    <div class="order-main">
      <div style="font-size: small;margin: 10px;">{{ orderAppeal }}</div>
      <van-divider dashed style="color: #4d84e2;margin: 3px;"></van-divider>
      <van-button size="default" type="info" color="cornflowerblue" style="margin-top: 20px" v-for="(item, index) in buttonStrs" :key="index" @click="handleCancleBea(item)">{{item}}</van-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "CancelOrder",
  data(){
    return {
      orderAppeal: "取消任务",
      buttonStrs:[
          "我不想做了",
          "找不到产品",
          "价格不对",
          "不符合商家要求",
          "无法验证",
          "我不取消了"
      ]
    }
  },
  mounted() {
    this.$emit("titleChange", "取消任务");
  },
  methods: {
    handleCancleBea(val){
      console.log(val)
    }
  }
}
</script>

<style lang="scss" scoped>
.order-main {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  margin-left: 1%;
  width: 98%;
}
</style>
